import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { CsvImportInterface } from "src/store/callrecorder/csvImportsSlice";
import { selectProviderById } from "src/store/callrecorder/providersSlice";
import { useAppSelector } from "src/store/hooks";
import RowInfo from "src/componets/RowInfo";

const _SidebarShow = ({ record }: { record: CsvImportInterface | undefined }) => {
  const provider = useAppSelector(state =>
    record ? selectProviderById(state, record.provider_id) : undefined
  );

  const renderDetails = () => {
    if(!record) {
      return null;
    }

    const providerLabel = provider
      ? `${provider.name}#${record.provider_id}`
      : `#${record.provider_id}`;

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Import Information</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='Type' right={record.import_type} />
          <RowInfo left='Provider' right={providerLabel} />
          <RowInfo
            left='Status'
            right={
              (() => {
                const map: Record<string, { color: string; label: string }> = {
                  pending:    { color: 'default',    label: 'Pending' },
                  processing: { color: 'processing', label: 'Processing' },
                  completed:  { color: 'success',    label: 'Completed' },
                  failed:     { color: 'error',      label: 'Failed' },
                };
                const tag = map[record.status] || map.pending;
                return <Tag color={tag.color}>{tag.label}</Tag>;
              })()
            }
          />
          <RowInfo left='Message' right={record.msg || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Progress</h6>

          <RowInfo left='Progress' right={`${record.progress}%`} />
          <RowInfo left='Processed Rows' right={`${record.processed_rows} / ${record.total_rows}`} />
          <RowInfo
            left='Error Rows'
            right={
              record.error_rows > 0
                ? <Tag color="error">{record.error_rows}</Tag>
                : record.error_rows
            }
          />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>IMPORT DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
